import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { newpasswordApi } from "../network/Network";

const CreateNewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location?.state ?? {};
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [newpassword1, setNewpassword1] = useState(false);
  const [cpassword1, setCpassword1] = useState(false);

  // New Password Handler 
  const newPasswordHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    let data = {
      email: email,
      password: password,
      confirm_password: cpassword,
    };
    newpasswordApi(data)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Your Email has been sent",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/signin");
        setLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          position: "center",
          icon: "error",
          text: `${err?.response?.data?.errors?.email[0]}`,
          showConfirmButton: false,
          timer: 1500,
        });
        setLoading(false);
      });
  };
  // ======================

  return (
    <>
      <div className="main-banner-heading1">
        <Header />
      </div>
      <section className="signin">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="main-bg-signin">
                <h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
                  Create New Password{" "}
                </h2>
                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <div className="form-group">
                      <input
                        type={newpassword1 ? "text" : "password"}
                        className="form-control"
                        id="firstName"
                        placeholder="Create New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button
                        className="input-inline-btn shop-password"
                        type="button"
                        onClick={() => setNewpassword1(!newpassword1)}
                      >
                        <i
                          className={
                            newpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
                          }
                        ></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-12 mb-2">
                    <div className="form-group">
                      <input
                        type={cpassword1 ? "text" : "password"}
                        className="form-control"
                        id="firstName"
                        placeholder="Confirm Password"
                        name="confirm_password"
                        value={cpassword}
                        onChange={(e) => setCpassword(e.target.value)}
                      />
                      <button
                        className="input-inline-btn shop-password"
                        onClick={() => setCpassword1(!cpassword1)}
                        type="button"
                      >
                        <i
                          className={
                            cpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
                          }
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <Link className="btn wrapper-btn-main w-100 log-in mt-2 level-7 primary-regular-font text-decoration-none">
                      <span
                        onClick={newPasswordHandler}
                        className="loading-btn loading bg-wrapper w-100"
                      >
                        {loading ? <i className="fa fa-spinner"></i> : "Submit"}
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default CreateNewPassword;
